interface AnkhSpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeMap = {
  sm: 'text-xl',
  md: 'text-3xl',
  lg: 'text-5xl',
};

export function AnkhSpinner({ className = '', size = 'md' }: AnkhSpinnerProps) {
  return (
    <span
      className={`inline-block animate-spin ${sizeMap[size]} ${className}`}
      role="status"
      aria-label="Loading"
    >
      ☥
    </span>
  );
}
